import Vue from 'vue';

Vue.directive('background-image', function (el, binding) {
  if (binding.value.opacityMask) {
    el.style.background = `linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) ), url('${ binding.value.imageUrl }')`;
    console.log('el.style.background', el.style.background);
  } else {
    el.style.backgroundImage = `url('${binding.value.imageUrl}')`;
  }
  el.style.backgroundSize = 'cover';
  el.style.backgroundPosition = 'center';
});

Vue.directive('tiled-background-image', function (el, binding) {
  if (binding.value) el.style.backgroundImage = `url('${binding.value}')`;
});

Vue.directive('background-color', function (el, binding) {
  if (binding.value) el.style.backgroundColor = binding.value;
});

Vue.directive('border-color', function (el, binding) {
  if (binding.value) el.style.borderColor = binding.value;
});

Vue.directive('color', function (el, binding) {
  if (binding.value) el.style.color = binding.value;
});

Vue.directive('font-style', function (el, binding) {
  if (binding.value) {
    el.style.fontFamily = `${binding.value.fontFamily}, Arial, Sans-Serif`;
    el.style.fontWeight = binding.value.fontWeight;
    if (binding.value.uppercase) el.style.textTransform = 'uppercase';
  }
});

Vue.directive('modify-leading', function (el, binding) {
  if (binding.value && binding.value.modifyLeading) el.style.marginTop = `${-binding.value.modifyLeading}px`;
});

Vue.directive('modify-input-leading', function (el, binding) {
  if (binding.value && binding.value.modifyInputLeading) el.style.paddingTop = `${-binding.value.modifyInputLeading}px`;
});
